import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmashStripeComponent } from './smash-stripe/smash-stripe.component';



@NgModule({
  declarations: [
    SmashStripeComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SmashStripeComponent
  ]
})
export class SmashStripeModule { }
